import { nav } from '../../copy/shell';
import s from './SkipLink.module.css';

/**
 * The first focusable thing on every page.
 *
 * A keyboard user who lands on Activity otherwise tabs through six nav items and a
 * footer before reaching the table they came for, on every navigation.
 */
export function SkipLink() {
  return (
    <a className={s.skipLink} href="#main">
      {nav.skipToContent}
    </a>
  );
}

export default SkipLink;
